module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-lightning-0c4acfdc.svg";